export * from './http-status-codes';
export * from './in-memory-backend.service';
export * from './in-memory-web-api.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/node_modules/angular-in-memory-web-api/index.js
// module id = ../../../../angular-in-memory-web-api/index.js
// module chunks = vendor